import "../styles/loading.css";

export const GlobalLoadingSpinner = () => {
    return (
        <div className="d-flex position-absolute ar-gobal-loading-container">
            {window.useGaiaDesign ?
                <span className="ga-spinner spinner-lg"></span> :
                <span className="spinner spinner-secondary-grey"></span>
            }
        </div>
    );
}